// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xPbb","toggle":"styles_toggle__292na","preview":"styles_preview__3gzRY"};